import { LoadingOutlined } from "@ant-design/icons";
import {} from "antd";
import { Input, notification, Spin } from "antd";
import SVG from "components/common/SVG";
import { useState } from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";

import { getUploadPicture } from "../../../../store/videogrid/duck";
import { editWorkspace } from "../../../../store/workspace/duck";
import CustomModal from "../CustomModal";
import styles from "./style.module.scss";

const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;

const mapDispatchToProps = {
  getUploadPicture,
  editWorkspace,
};

const EditWorkspaceModal = ({ getUploadPicture, editWorkspace, workspace, closeAndFetchModal, setShowModal }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(workspace?.displayName);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(workspace?.logo);

  const handleEditWorkspace = async () => {
    try {
      setLoading(true);
      const payload = {
        name,
        logo: uploadedImageUrl,
        workspaceId: workspace?.workspaceId,
      };

      const response = await editWorkspace(payload);
      if (response?.value?.status) {
        notification.success({ message: response?.value?.message });
      }

      closeAndFetchModal();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const uploadFileAndGetUrl = async (data, type) => {
    setLoading(true);
    if (type !== "image") {
      notification["warning"]({ message: "Wrong file uploaded!" });
    } else {
      const { value } = await getUploadPicture(data);
      if (value.status) {
        setUploadedImageUrl(value.data);
      }
      setLoading(false);
    }
  };

  const onDrop = async (acceptedFiles) => {
    const files = acceptedFiles;
    const file = files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = async () => {
          const data = new FormData();
          data.append("file", file);
          data.append("filename", file.name);
          let type = file?.type.split("/")[0];
          let title = file.name;
          await uploadFileAndGetUrl(data, type, title);
        };
      };
      reader.readAsDataURL(file);
    } else {
      notification["warning"]({ message: "Please select valid file!" });
    }
  };

  return (
    <>
      <CustomModal
        showModal={!!workspace}
        setShowModal={setShowModal}
        contentLabel="Edit Workspace"
        primaryCtaText="Save"
        secondaryCtaText="Close"
        primaryCtaHandler={handleEditWorkspace}
        secondaryCtaHandler={() => setShowModal(false)}
        primaryCtaEnabled={name && uploadedImageUrl}
      >
        <div className={styles.formContainer}>
          <div className={styles.formItem}>
            <div className={styles.formItemLabel}>Workspace name</div>
            <Input className={styles.textInput} value={name} onChange={(e) => setName(e.target.value)} />
          </div>

          <div className={styles.formItem}>
            <div className={styles.formItemLabel}>Workspace logo</div>

            <Dropzone accept="image/*" multiple={false} onDrop={onDrop}>
              {({ getRootProps, getInputProps }) => (
                <>
                  {/* <div className={styles.dropzoneContainer} {...getRootProps()}>
                    <input {...getInputProps()} /> */}

                  {uploadedImageUrl ? (
                    <div className={styles.dropZoneWithUpload}>
                      <div className={styles.dropzone}>
                        <img src={uploadedImageUrl} className={styles.previewImage} alt="preview" />
                      </div>
                      <div className={styles.dropzoneContainer} {...getRootProps()}>
                        <input {...getInputProps()} />
                        <div className="style_profilePictureCta__-++QG">Update picture</div>
                      </div>
                    </div>
                  ) : (
                    <div className={styles.dropzone}>
                      <div className={styles.dropzoneContainer} {...getRootProps()}>
                        <input {...getInputProps()} />

                        <SVG iconName={"images/upload.svg"} className={styles.dropzoneIcon} />
                        {loading ? <Spin indicator={antIcon}></Spin> : ""}

                        <div className={styles.browseCta}>Browse</div>
                        <div className={styles.dropdownText}>or drag & drop your file here</div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </Dropzone>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default connect((/*state*/) => ({}), mapDispatchToProps)(EditWorkspaceModal);
